<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17IpaAS/tc-custom/9781488007156.jpg?1720019854944" alt="This image is the cover for the book Firefighter Daddy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Firefighter Daddy
      </h1>
      <p class="bookDescription body article font2">
        <p>From Bachelor to Father<br/><br/>Firefighter Liam McGregory is used to staring down fivealarm firesbut becoming a father to his two little nieces has him sending out a call for help. When the girls return a lost pup to its beautiful owner, Liam thinks widow Sarah Blackburn is just the person he needsor who the children need. <i>He's</i> promised to never marry again. ' Sarah takes his deal: she'll watch his kids and he'll watch her menagerie of petsbut the new father is off-limits. But two determined little matchmakers can be hard to resist when they need a mom to make one big happy family</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Daley
      </h2>
      
      <p class="authorDescription body article">Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn&rsquo;t traveling, she&rsquo;s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60aef09c